import React, { useEffect, useState } from "react";
import { X, Trash2 } from "lucide-react";
import CourseCardMinimalCart from "../CourseCard/CourseCardMinimalCart";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { AddToCartClientApp, PlaceOrderClientApp, razorpayPaymentAPIClient } from "../../store/actions/Purchase/PurchaseApi";

export default function CartSidebar({
  isOpen,
  cartItems,
  onClose,courseThemeCard1Object, 
  onRemoveItem,
}) {

const dispatch = useDispatch();
           const currentToken = useSelector((state)=>state?.user?.user?.currentToken);
                 const userEmail = useSelector((state)=>state?.user?.user?.userData?.userEmail
                );
                
                    const userData =useSelector((state)=>state?.user?.user);
                   const AppToken = useSelector((state)=>state?.user?.user?.appToken);
                   const appId = useSelector((state)=>state?.user?.user?.appId);
                 
                              const [visibility,setVisibility] =useState("public");
                     const [orderBy,setOrderBy] =useState("ASC");
                       const [snackbarVisible, setSnackbarVisible] = useState(false);
                                             const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                                             const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                                       
                                              
                                          const showSnackbar = () => {
                                            setSnackbarVisible(true);
                                          };
                                         
                                          const hideSnackbar = () => {
                                            setSnackbarVisible(false);
                                          };
                                    
                                               const [loader , setLoader] =useState({status:true});
                                  const  [itemArr ,setItemArr]=useState([])
                             const  [cart ,setCart]=useState([])
                          
        function handleCreateOrder(value,appName,backend_order_id) {
 
      // 1) Call WP REST endpoint to create Razorpay order
onClose();
                    const apiData = dispatch(razorpayPaymentAPIClient(({ amount: value,userEmail:userEmail?userEmail:"",clientCurrentToken:currentToken?currentToken:"",
          })));
                    /* get response as Promise   */
                    apiData.then(response => {
                    
                    const data = response;
     
// console.log(data)
      const { razorpay_key_id, razorpay_order_id, amount, currency } = {
        razorpay_key_id: data.razorpay_key_id, // fallback below if formatting issue
        razorpay_order_id: data.razorpay_order_id,
        amount: data.amount,
        currency: data.currency
      };

      // 2) dynamically load Razorpay checkout script if not already loaded
       loadRazorpayScript();

      // 3) open checkout
    const options = {
  key: data.razorpay_key_id,
  amount: data.amount,
  currency: data.currency,
  name: appName,
  description: "Please Complete Your Order",
  order_id: data.razorpay_order_id,

  handler: function (response) {
    console.log("Payment Response:", response);
console.log({userEmail:userEmail?userEmail:"",
           clientCurrentToken:currentToken?currentToken:"",paymentType:"cart_totals",order_id:backend_order_id,payment_callback:true,is_paid:true,
          payment_id:response?.razorpay_payment_id,rz_order_id:response?.razorpay_order_id,payment_method:"razorpay",status:'active'})
    firePlaceOrderCallbackClientApp({userEmail:userEmail?userEmail:"",
           clientCurrentToken:currentToken?currentToken:"",paymentType:"cart_totals",order_id:backend_order_id,payment_callback:true,is_paid:true,
          payment_id:response?.razorpay_payment_id,rz_order_id:response?.razorpay_order_id,payment_method:"razorpay",status:'active'})
  },

  prefill: {
    name: "Kaushal Gedam" || "",
    email: "kaushalgedam1@gmail.com" || "",
    contact: "9284278051" || "",
  },

  notes: {
    platform: "TestPrism",
    plan: "MockTest Premium",
  },

  theme: {
    color: "#3399cc",
  },

  modal: {
    ondismiss: function () {
      console.log("Checkout closed by user");
    }
  }
};
      const rzp = new window.Razorpay(options);
      rzp.open();
                    }).catch(error => {
                   
                      //popup of error Info
                      setResponseMessage("Something Went Wrong...");
                        
                      setSnackbarColor("#958FDA");
                   
                      
                       
                  setLoader({status:false});
                  
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                      console.error(error);
                    });
      
      
    
  
  }
      
     function loadRazorpayScript() {
    return new Promise((resolve, reject) => {
      if (window.Razorpay) return resolve();
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Razorpay SDK failed to load.'));
      document.body.appendChild(script);
    });
  }    
      
      
                             const fireAddToCartClientApp=(action,item)=>{
              
              setLoader({status:true});
        //           console.log({userEmail:userEmail?userEmail:"",
        //    clientCurrentToken:currentToken?currentToken:"",paymentType:"price",
        //     action:action,courseId:item?.ID,productId:item?.price?.pricePlan?.ID,appToken:AppToken,appId:appId,visibility:visibility});
    
                    const apiData = dispatch(AddToCartClientApp({userEmail:userEmail?userEmail:"",
           clientCurrentToken:currentToken?currentToken:"",paymentType:"price",
            action:action,courseId:item?.ID,productId:item?.price?.pricePlan?.ID}));
                    /* get response as Promise   */
                    apiData.then(response => {
                    //   console.log(response)
              
                      if(response){
                       setItemArr(response?.productsInCart);
                       setCart(response)
                        if(response){
                      setResponseMessage(response?.message);
                      setSnackbarColor("rgba(144, 202, 249,1)");
                    
                  setLoader({status:false});
                  
                  // setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                  },1000)
                     }else{
                 
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                     }
                        
                      
                     if(response?.logout){
                     
                      setResponseMessage("You are Logged Out!!!");
                        
                      setSnackbarColor("#958FDA");
                    
                      
                       
                  setLoader({status:false});
                  
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                      setTimeout(()=>{
                        dispatch({type:"LOGOUT"});
                  
                      },3000)
                      
                    }
                  
                      }else{
                        setResponseMessage("Something Went Wrong...");
                        
                        setSnackbarColor("#958FDA");
                      
                         
                    setLoader({status:false});
                    
                    setSnackbarVisible(true);
                    setTimeout(()=>{
                      
                      setSnackbarVisible(false);
                     
                       
                    },3000)    }
                  
                    }).catch(error => {
                   
                      //popup of error Info
                      setResponseMessage("Something Went Wrong...");
                        
                      setSnackbarColor("#958FDA");
                   
                      
                       
                  setLoader({status:false});
                  
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                      console.error(error);
                    });
               }
               const firePlaceOrderClientApp=(sendObject)=>{
              
              setLoader({status:true});
          //         console.log({userEmail:userEmail?userEmail:"",
          //  clientCurrentToken:currentToken?currentToken:"",paymentType:"cart_totals",
          //   appToken:AppToken,appId:appId});
    
                    const apiData = dispatch(PlaceOrderClientApp(sendObject));
                    /* get response as Promise   */
                    apiData.then(response => {
                      // console.log(response)
           if(response?.orders?.length){ handleCreateOrder(cart?.cartWithTAX?.total_with_tax,response?.appName,response?.currentOrderId)
                  } else{alert("Error Occured")} 
                    }).catch(error => {
                   
                      //popup of error Info
                      setResponseMessage("Something Went Wrong...");
                        
                      setSnackbarColor("#958FDA");
                   
                      
                       
                  setLoader({status:false});
                  
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                      console.error(error);
                    });
               }
                  const firePlaceOrderCallbackClientApp=(sendObject)=>{
              
              setLoader({status:true});
          //         console.log({userEmail:userEmail?userEmail:"",
          //  clientCurrentToken:currentToken?currentToken:"",paymentType:"cart_totals",
          //   appToken:AppToken,appId:appId});
    
                    const apiData = dispatch(PlaceOrderClientApp(sendObject));
                   
                    /* get response as Promise   */
                    apiData.then(response => {
                      console.log(response)
                   
                    }).catch(error => {
                   
                      //popup of error Info
                      setResponseMessage("Something Went Wrong...");
                        
                      setSnackbarColor("#958FDA");
                   
                      
                       
                  setLoader({status:false});
                  
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                      console.error(error);
                    });
               }
               
useEffect(()=>{
    setTimeout(()=>{
          fireAddToCartClientApp("")
    },1000)
  
},[isOpen])
  
  const subtotal = cartItems.reduce((sum, item) => sum + item?.price * item?.qty, 0);

  return (
    <>
      {/* Overlay */}
     

      {/* Sidebar */}
     <div className={`overlay ${isOpen ? "active" : ""}`} onClick={onClose}></div>

<div className={`cart-sidebar ${isOpen ? "open" : ""}`}>
  <div className="cart-header">
    <h2>Your Cart</h2>
    <button className="close-btn" onClick={onClose}>×</button>
    
  </div>
<h4>{cart?.cartMessage}</h4>
  <div className="cart-items">
    {!itemArr?.length? (
      <p className="empty">Cart is empty</p>
    ) : (
      itemArr?.map(item => (
       <CourseCardMinimalCart  removeItem={(v)=>{fireAddToCartClientApp("remove",item?.course)}} courseThemeCard1Object={courseThemeCard1Object} item={item} />
      ))
    )}
  </div>

  {itemArr?.length > 0 && (
    <div className="cart-footer">
        <div>  <div className="subtotal">
        <span>Subtotal</span>
        <span>₹{cart?.cartTotal}</span>
      </div> 
      {/* <div className="subtotal"> <span>Before Tax</span><span>₹{cart?.cartWithTAX?.cart_total_before_tax}</span></div> */}
<div className="subtotal">
        <span>Total Tax (18%)</span><span>+₹{cart?.cartWithTAX?.total_tax}</span></div>
        <div className="subtotal">
        <span>Total Payable</span><span>₹{cart?.cartWithTAX?.total_with_tax}</span></div>
            
            
        </div>
    
      <button className="checkout-btn" onClick={()=>{firePlaceOrderClientApp({userEmail:userEmail?userEmail:"",
           clientCurrentToken:currentToken?currentToken:"",paymentType:"cart_totals",payment_callback:false
          })}}>Checkout</button>
    </div>
  )}
</div>
<style>{`/* Overlay */
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  opacity: 0;
  visibility: hidden;z-index:9999999;
  transition: 0.3s;
}
.overlay.active {
  opacity: 1;
  visibility: visible;
}

/* Sidebar */
.cart-sidebar {
  position: fixed;
  top: 0;
  right: 0;
  width: 320px;
  bottom:0px;
  background: #fff;
  transform: translateX(100%);
  transition: 0.3s ease;
  box-shadow: -4px 0 15px rgba(0,0,0,0.1);
  padding: 10px;
  display: flex;
  flex-direction: column;
  z-index:99999999;
}
.cart-sidebar.open {
  transform: translateX(0);
}

/* Header */
.cart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}
.cart-header h2 {
  font-size: 18px;
  font-weight: bold;
}
.close-btn {
  font-size: 22px;
  border: none;
  background: none;
  cursor: pointer;
}

/* Items */
.cart-items {
  flex: 1;
  overflow-y: auto;overflow-x:hidden;
  margin-top: 15px;
}
.cart-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  gap: 10px;
}
.cart-item img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 5px;
}
.cart-item .info h4 {
  margin: 0;
  font-size: 14px;
}
.cart-item .price {
  color: #555;
  font-size: 12px;
}
.cart-item .remove {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
}

/* Empty State */
.empty {
  color: #444;
  text-align: center;
  margin-top: 50px;
}

/* Footer */
.cart-footer {
  border-top: 1px solid #eee;
  padding-top: 10px;
}
.subtotal {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
}
.checkout-btn {
  background: #111111;
  width: 100%;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 15px;
}
.checkout-btn:hover {
  background: #333333;
}
`}</style>
    </>
  );
}
